function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import { PiShoppingCart } from "react-icons/pi";
import Alert from "@mui/material/Alert";
import BrokerOption from "../../../../components/react-select/BrokerOption";
import BrokerSingleValue from "../../../../components/react-select/BrokerSingleValue";
import SelectField from "../../../../components/redux-form/SelectField";
import { loadInvestmentItemById, loadInvestmentAccountsByUserId } from "../../../../actions";
import { operationTypes } from "../../../../constants";
var tKey = "contexts.ExchangeContext.CreateExchangeModal.ExchangeWizardForm.ExchangeWizardFormBrokerStep";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormBrokerStep(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var type = useSelector(function (state) {
    return selector(state, "type");
  });
  var quote = useSelector(function (state) {
    return selector(state, "quote");
  });
  var broker = useSelector(function (state) {
    return selector(state, "broker");
  });
  var variantInvestmentItem = useSelector(function (state) {
    return selector(state, "variantInvestmentItem");
  });
  var variantInvestmentItemId = variantInvestmentItem.id;
  var variantInvestmentItemCall = useSelector(function (state) {
    return state.apiCalls.loadInvestmentItemById[variantInvestmentItemId] || {};
  });
  variantInvestmentItem = useSelector(function (state) {
    return state.entities.investmentItems.byId[variantInvestmentItemId];
  });
  var investmentAccountsCall = useSelector(function (state) {
    return state.apiCalls.loadInvestmentAccountsByUserId[authUserId] || {};
  });
  var investmentAccounts = useSelector(function (state) {
    return state.entities.investmentAccounts.byUserId[authUserId];
  });
  var brokerGroupedOptions;
  if (variantInvestmentItem && investmentAccounts) {
    var brokerOptions = variantInvestmentItem.effectiveAvailabilities.filter(function (availability) {
      return type === operationTypes.BUY && availability.buyEnabled || type === operationTypes.SELL && availability.sellEnabled;
    }).map(function (availability) {
      return _objectSpread({
        label: availability.broker.name,
        value: availability.broker.id
      }, availability.broker);
    });
    brokerGroupedOptions = [{
      label: t("".concat(tKey, ".withAccount")),
      options: brokerOptions.filter(function (brokerOption) {
        return investmentAccounts.find(function (investmentAccount) {
          return investmentAccount.broker.id === brokerOption.id;
        });
      })
    }, {
      label: t("".concat(tKey, ".withoutAccount")),
      options: brokerOptions.filter(function (brokerOption) {
        return !investmentAccounts.find(function (investmentAccount) {
          return investmentAccount.broker.id === brokerOption.id;
        });
      })
    }];
  }
  useEffect(function () {
    props.loadInvestmentAccountsByUserId(authUserId);
  }, []);
  useEffect(function () {
    if (!broker) return;
    var investmentAccount = investmentAccounts && investmentAccounts.find(function (account) {
      return account.broker.id === broker.id;
    });
    props.change("investmentAccount", investmentAccount);
  }, [broker, investmentAccounts]);
  useEffect(function () {
    variantInvestmentItem && props.change("variantInvestmentItemRoot", variantInvestmentItem.root);
    if (brokerGroupedOptions && brokerGroupedOptions[0].options.length === 1) props.change("broker", brokerGroupedOptions[0].options[0]);else if (brokerGroupedOptions && brokerGroupedOptions[0].options.length === 0 && brokerGroupedOptions[1].options.length === 1) props.change("broker", brokerGroupedOptions[1].options[0]);
  }, [variantInvestmentItem]);
  var noInvestmentAccount = investmentAccounts && broker && !investmentAccounts.some(function (account) {
    return account.broker.id === broker.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectField, {
    name: "broker",
    id: "broker",
    isLoading: variantInvestmentItemCall.isFetching || investmentAccountsCall.isFetching,
    options: brokerGroupedOptions,
    components: {
      Option: BrokerOption,
      SingleValue: BrokerSingleValue
    },
    isDisabled: type === operationTypes.SELL || quote
  }), noInvestmentAccount && /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    sx: {
      alignItems: "center",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".investmentAccountNotFound"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null),
      icon: /*#__PURE__*/React.createElement(PiShoppingCart, null)
    }
  })));
}
export default connect(undefined, {
  loadInvestmentItemById: loadInvestmentItemById,
  loadInvestmentAccountsByUserId: loadInvestmentAccountsByUserId
})(ExchangeWizardFormBrokerStep);
ExchangeWizardFormBrokerStep.propTypes = {
  loadInvestmentItemById: PropTypes.func,
  loadInvestmentAccountsByUserId: PropTypes.func
};